import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HotComics from "./components/HotComics";
import Categories from "./components/Categories";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [search, setSearch] = useState("");
  const [genre, setGenre] = useState("");

  const goComics = () => {
    document.getElementById("comics")?.scrollIntoView({ behavior: "smooth" });
  };

  const selectCategory = (name: string) => {
    setGenre(name);
    goComics();
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero search={search} setSearch={setSearch} onSearch={goComics} />
        <Features />
        <HotComics search={search} genre={genre} setGenre={setGenre} />
        <Categories onSelect={selectCategory} />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}